
export class Validation {
    isFirstNameInvalid: boolean; 
    isLastNameInvalid: boolean;
    isDOBInvalid: boolean;
    isEmailInvalid: boolean;
    isEmailNotValidated: boolean;
    isAccountNameInvalid: boolean;
    isPasswordInvalid: boolean;
    isConfirmPasswordInvalid: boolean;
    isQuestionInvalid: boolean;
    isAnswerInvalid: boolean;
    isPolicyInvalid: boolean;
    isMobileOptInInvalid: boolean;
}